module.exports = "<div class=\"my-lists-container navigation\">\r\n    <a ui-sref=\"shop.list\">\r\n        <h2 class=\" navigation-header\">\r\n            My <span class=\"sr-only\">saved</span> Lists\r\n        </h2>\r\n    </a>\r\n    <wow-suggested-list></wow-suggested-list>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/lists/views/suggested-lists.html
// module id = 623
// module chunks = 0